/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawerAppliedFilterDisplay_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
    readonly " $refType": "SbRespRefineMenuDrawerAppliedFilterDisplay_user";
};
export type SbRespRefineMenuDrawerAppliedFilterDisplay_user$data = SbRespRefineMenuDrawerAppliedFilterDisplay_user;
export type SbRespRefineMenuDrawerAppliedFilterDisplay_user$key = {
    readonly " $data"?: SbRespRefineMenuDrawerAppliedFilterDisplay_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'eb721814f3d30d72590c56260c12f3af';
export default node;
